export const SET_IS_MOBILE = (state, val) => {
  state.isMobile = val;
}

export const SAVE_MAIL_TYPES = (state, val) => {


  state.mailTypes = val.sort((a, b) => {
    if (a.id < b.id)
      return -1;

    if (a.id > b.id)
      return 1;

    return 0;
  });
}

export const SAVE_COUNTRY_LIST = (state, val) => {
  const sortList = (list) => {
    let US = list.find(item => item.code == 'US')
    list = list.filter(item => item.code != 'US');

    list.sort((a, b) => {
      if (a.name > b.name)
        return 1;

      if (a.name < b.name)
        return -1;

      return 0;
    });

    return [US, ...list];
  }

  // let cList = val.sort((a, b) => a.id - b.id);
  let cList = sortList(val);
  state.countryList = cList;
  localStorage.setItem('countryList', JSON.stringify(cList));

  // Save available countries to phoneProps.onlyCountries
  let arr = [];
  cList.forEach(country => {
    if (country.code) {
      if (country.code !== 'UK')
        arr.push(country.code);
      else
        arr.push('GB');
    }
  });
  state.phoneProps.onlyCountries = arr;
}

export const SAVE_COUNTRY_DATA = (state, val) => {
  state.countryList.find(country => {
    if (country.id == val.id) {
      country.states = val.states;
      country.taxes = val.taxes;
      return true;
    }

    return false;
  });
  localStorage.setItem('countryList', JSON.stringify(state.countryList));
}

// export const SAVE_STATE_LIST = (state, val) => {
//   state.countryList.find(country => {
//     if (country.id == val.id) {
//       country.states = val.list;
//       return true;
//     }

//     return false;
//   });
// localStorage.setItem('countryList', JSON.stringify(state.countryList));
// }

export const SAVE_CURRENCY_LIST = (state, val) => {
  state.currencyList = val;
  localStorage.setItem('currencyList', JSON.stringify(val));
}

export const SAVE_PROVIDER = (state, val) => {
  state.provider = val.client;
}

export const UPDATE_GLOBAL_NOTIFICATION = (state, val) => {
  state.globalNotification = val;
}

export const SET_IS_ADMIN = (state, val) => {
  state.isAdmin = val;
}

export const SET_POPUP_STATE = (state, val) => {
  state.popupOpen = val;
}

export const SAVE_REMINDERS_LIST = (state, val) => {
  // state.reminders = val
  let res = {}
  Object.keys(val).forEach(key => {
    if (key != 'reminders' || !state.reminders || val.page == 1)
      res[key] = val[key];
    else 
      res[key] = [...state.reminders[key], ...val[key]];
  });

  state.reminders = res;
}

export const SET_REMINDERS_READ = (state) => {
  state.reminders.total_unread_reminders = 0;
}

export const SAVE_NOTIFICATIONS_LIST = (state, val) => {
  // state.notifications = val
  let res = {}

  Object.keys(val).forEach(key => {
    if (key != 'notifications' || !state.notifications || val.page == 1)
      res[key] = val[key];
    else 
      res[key] = [...state.notifications[key], ...val[key]];
  });

  state.notifications = res;
}

export const SET_NOTIFICATIONS_READ = (state) => {
  state.notifications.total_unread_notifications = 0;
}

export const ADD_NOTIFICATION = (state, val) => {
  state.notifications.notifications = [val, ...state.notifications.notifications];
}

export const UPDATE_NOTIFICATION = (state, val) => {
  let index = state.notifications.notifications.findIndex(item => item.id == val.id);

  state.notifications.notifications[index] = val;
}

export const REMOVE_NOTIFICATION = (state, id) => {
  let index = state.notifications.notifications.findIndex(item => item.id == id);

  state.notifications.notifications.splice(index, 1);
}


export const SAVE_ANNOUNCEMENTS_LIST = (state, val) => {
  // state.notifications = val
  let res = {}

  Object.keys(val).forEach(key => {
    if (key != 'announcements' || !state.announcements || val.page == 1)
      res[key] = val[key];
    else 
      res[key] = [...state.announcements[key], ...val[key]];
  });

  state.announcements = res;
}

export const ADD_ANNOUNCEMENT = (state, val) => {
  state.announcements.announcements = [val, ...state.announcements.announcements];
}

export const UPDATE_ANNOUNCEMENT= (state, val) => {
  let index = state.announcements.announcements.findIndex(item => item.id == val.id);

  state.announcements.announcements[index] = val;
}

export const REMOVE_ANNOUNCEMENT = (state, id) => {
  let index = state.announcements.announcements.findIndex(item => item.id == id);

  state.announcements.announcements.splice(index, 1);
}

export const SET_ANNOUNCEMENTS_READ = (state) => {
  state.announcements.total_unread_announcements = 0;
}

export const ADD_API_ERROR = (state, err) => {
  state.apiErrors.push(err);
}

export const REMOVE_API_ERROR = (state, id) => {
  let index = state.apiErrors.findIndex(err => err.id == id);

  state.apiErrors.splice(index, 1);
}

export const SET_POPUP_ERROR = (state, { title, text, content}) => {
  state.popupError = {
    isOpen: true,
    title: title,
    text: text,
    content: content
  };
}

export const CLEAR_POPUP_ERROR = (state) => {
  console.log("CLEAR_POPUP_ERROR")
  state.popupError = {};
}